import { connect } from 'react-redux';
import { bindActionCreators, Dispatch, Action } from 'redux';

import { selectStartupDetails } from 'redux/selectors/startups';
import { checkIsUserAuthenticated, logout } from 'redux/actions/auth';
import { getStartupById } from 'redux/actions/startups';
import { selectUserType } from 'redux/selectors/auth';
import { StateType } from 'types';

const mapStateToProps = (state: StateType) => ({
  userType: selectUserType(state),
  startupData:  selectStartupDetails(state),
});

const mapDispatchToProps = (dispatch: Dispatch<Action>) => ({
  actions: bindActionCreators({
    checkIsUserAuthenticated,
    getStartupById,
    logout,
  }, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps);
